import { FC, useEffect, useState } from 'react'
import { FLOWCODE_MARKETING_BASE_URL, Routes } from '@dtx-company/true-common/src/constants/routes'
import { HeaderLogo } from '../../layout/header/v2/HeaderLogo'
import { MarketingNavLinks } from '../../layout/header/v2/MarketingNavLinks'
import { MarketingTopNavProps } from './MarketingTopNavProps'
import { TopNavV2 } from '../../../containers/nav/top/v2'
import styled from 'styled-components'

const NavLinksWrapper = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  width: 100%;
  justify-content: center;
`

export const MarketingTopNav: FC<MarketingTopNavProps> = props => {
  const [logoRoute, setLogoRoute] = useState(FLOWCODE_MARKETING_BASE_URL)

  // we allow internal users to access the print store
  useEffect(() => {
    if (props.isPrintStoreRoute) {
      setLogoRoute(Routes.CODES)
    }
  }, [props.isPrintStoreRoute])

  const logo = <HeaderLogo href={logoRoute} isNextLink={Boolean(props.isPrintStoreRoute)} />
  return (
    <TopNavV2
      {...props}
      logo={logo}
      shouldShowPlatformTopNav={false}
      backgroundColor="primary.white"
    >
      <NavLinksWrapper>
        <MarketingNavLinks isLoggedIn={props.isLoggedIn} isFPHomepage={props.isFlowpageRoute} />
      </NavLinksWrapper>
    </TopNavV2>
  )
}
